const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M6 3.25A3.75 3.75 0 0 0 2.25 7v10A3.75 3.75 0 0 0 6 20.75h12A3.75 3.75 0 0 0 21.75 17V9A3.75 3.75 0 0 0 18 5.25h-5.842c-.543 0-.87-.345-1.197-.72a3.75 3.75 0 0 0-2.822-1.28z" clip-rule="evenodd"/></svg>';
export {
  e as w
};
